import React from "react";
import Login from "../components/login/login";
import Navbar from "../components/homePage/navBar";

const LoginPage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <Login />
    </div>
  );
};

export default LoginPage;
